"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState, type JSX } from "react";
import { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { getRandomColorWithSeed } from "@/helpers/Helpers";
import GroupCardView from "./GroupCardView";
import { AuthContext } from "@/components/auth/Auth";
import { useRouter } from "next/navigation";
import GroupCardVoteAll from "./vote-all/GroupCardVoteAll";
import { ApiRateMatter } from "@/generated/models/ApiRateMatter";
export enum GroupCardState {
  IDLE = "IDLE",
  REP = "REP",
  NIC = "NIC",
}
export enum CreditDirection {
  ADD = "ADD",
  SUBTRACT = "SUBTRACT",
}
export default function GroupCard(t0) {
  const $ = _c(60);
  const {
    group,
    activeGroupIdVoteAll,
    setActiveGroupIdVoteAll,
    userPlaceholder,
    titlePlaceholder
  } = t0;
  const router = useRouter();
  const {
    connectedProfile
  } = useContext(AuthContext);
  const [state, setState] = useState(GroupCardState.IDLE);
  let t1;
  if ($[0] !== group?.created_by.banner1_color || $[1] !== group?.created_by.handle) {
    t1 = group?.created_by.banner1_color ?? getRandomColorWithSeed(group?.created_by.handle ?? "");
    $[0] = group?.created_by.banner1_color;
    $[1] = group?.created_by.handle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const banner1 = t1;
  let t2;
  if ($[3] !== group?.created_by.banner2_color || $[4] !== group?.created_by.handle) {
    t2 = group?.created_by.banner2_color ?? getRandomColorWithSeed(group?.created_by.handle ?? "");
    $[3] = group?.created_by.banner2_color;
    $[4] = group?.created_by.handle;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const banner2 = t2;
  let t3;
  if ($[6] !== group || $[7] !== setActiveGroupIdVoteAll) {
    t3 = state_0 => {
      if (!setActiveGroupIdVoteAll || !group) {
        return;
      }
      if (state_0 === GroupCardState.IDLE) {
        setActiveGroupIdVoteAll(null);
      } else {
        setActiveGroupIdVoteAll(group.id);
      }
      setState(state_0);
    };
    $[6] = group;
    $[7] = setActiveGroupIdVoteAll;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const onGroupStateChange = t3;
  let t4;
  if ($[9] !== activeGroupIdVoteAll || $[10] !== group?.id) {
    t4 = () => activeGroupIdVoteAll === group?.id;
    $[9] = activeGroupIdVoteAll;
    $[10] = group?.id;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const getIsActiveGroupVoteAll = t4;
  const isActiveGroupVoteAll = getIsActiveGroupVoteAll();
  let t5;
  if ($[12] !== isActiveGroupVoteAll) {
    t5 = () => {
      if (!isActiveGroupVoteAll) {
        setState(GroupCardState.IDLE);
      }
    };
    $[12] = isActiveGroupVoteAll;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  useEffect(t5);
  let t6;
  if ($[14] !== onGroupStateChange) {
    t6 = () => onGroupStateChange(GroupCardState.IDLE);
    $[14] = onGroupStateChange;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const onActionCancel = t6;
  let t7;
  if ($[16] !== connectedProfile?.handle || $[17] !== onGroupStateChange) {
    t7 = () => {
      if (!connectedProfile?.handle) {
        onGroupStateChange(GroupCardState.IDLE);
      }
    };
    $[16] = connectedProfile?.handle;
    $[17] = onGroupStateChange;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const t8 = connectedProfile?.handle;
  let t9;
  if ($[19] !== t8) {
    t9 = [t8];
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  useEffect(t7, t9);
  let t10;
  if ($[21] !== router) {
    t10 = group_0 => {
      router.push(`/network/groups?edit=${group_0.id}`);
    };
    $[21] = router;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const onEditClick = t10;
  const t11 = setActiveGroupIdVoteAll ? onGroupStateChange : undefined;
  const t12 = !!activeGroupIdVoteAll;
  const t13 = setActiveGroupIdVoteAll ? onEditClick : undefined;
  let t14;
  if ($[23] !== group || $[24] !== t11 || $[25] !== t12 || $[26] !== t13 || $[27] !== titlePlaceholder || $[28] !== userPlaceholder) {
    t14 = <GroupCardView group={group} setState={t11} haveActiveGroupVoteAll={t12} onEditClick={t13} userPlaceholder={userPlaceholder} titlePlaceholder={titlePlaceholder} />;
    $[23] = group;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
    $[27] = titlePlaceholder;
    $[28] = userPlaceholder;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== group || $[31] !== onActionCancel) {
    t15 = <GroupCardVoteAll group={group} onCancel={onActionCancel} matter={ApiRateMatter.Rep} />;
    $[30] = group;
    $[31] = onActionCancel;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== group || $[34] !== onActionCancel) {
    t16 = <GroupCardVoteAll group={group} onCancel={onActionCancel} matter={ApiRateMatter.Cic} />;
    $[33] = group;
    $[34] = onActionCancel;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t14 || $[37] !== t15 || $[38] !== t16) {
    t17 = {
      [GroupCardState.IDLE]: t14,
      [GroupCardState.REP]: t15,
      [GroupCardState.NIC]: t16
    };
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  const components = t17;
  const isIdle = state === GroupCardState.IDLE;
  const cardLabel = group?.name ?? titlePlaceholder ?? "View community group details";
  let t18;
  if ($[40] !== cardLabel || $[41] !== group?.id || $[42] !== isIdle || $[43] !== router) {
    t18 = isIdle && <button type="button" onClick={() => router.push(`/network?page=1&group=${group?.id}`)} className="tw-absolute tw-inset-0 tw-z-10 tw-rounded-2xl tw-border-0 tw-bg-transparent tw-p-0 tw-cursor-pointer focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-primary-500" aria-label={`Open ${cardLabel}`} />;
    $[40] = cardLabel;
    $[41] = group?.id;
    $[42] = isIdle;
    $[43] = router;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  const t19 = isIdle ? "tw-group" : "";
  const t20 = `linear-gradient(45deg, ${banner1} 0%, ${banner2} 100%)`;
  let t21;
  if ($[45] !== t20) {
    t21 = {
      background: t20
    };
    $[45] = t20;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="tw-absolute tw-inset-0 tw-rounded-t-2xl tw-ring-[1.5px] tw-ring-white/20 group-hover:tw-ring-white/40 tw-ring-inset tw-pointer-events-none tw-transition tw-duration-500 tw-ease-out" />;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== t21) {
    t23 = <div className="tw-relative tw-w-full tw-h-9 tw-rounded-t-2xl" style={t21}>{t22}</div>;
    $[48] = t21;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  const t24 = `${connectedProfile?.handle ? "tw-min-h-[134px]" : "tw-h-[123.5px]"} -tw-mt-1 tw-bg-iron-900 tw-flex tw-flex-col tw-rounded-b-2xl tw-relative tw-border-[1.5px] tw-border-solid tw-border-t-0 tw-border-iron-700 group-hover:tw-border-iron-600 tw-transition tw-duration-500 tw-ease-out`;
  const t25 = components[state];
  let t26;
  if ($[50] !== t24 || $[51] !== t25) {
    t26 = <div className={t24}>{t25}</div>;
    $[50] = t24;
    $[51] = t25;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t19 || $[54] !== t23 || $[55] !== t26) {
    t27 = <div className={t19}>{t23}{t26}</div>;
    $[53] = t19;
    $[54] = t23;
    $[55] = t26;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] !== t18 || $[58] !== t27) {
    t28 = <div className="tw-col-span-1 tw-relative">{t18}{t27}</div>;
    $[57] = t18;
    $[58] = t27;
    $[59] = t28;
  } else {
    t28 = $[59];
  }
  return t28;
}